import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class NoAuthGuard implements CanActivate {
    constructor(private readonly authService: AuthService, private readonly router: Router) { }

    async canActivate(): Promise<boolean> {
        // Wait for any user loading logic to finish
        await this.authService.loadUserFromStorage();

        const user = this.authService.getCurrentUser();
        if (user) {
            this.authService.redirectToDashboard(user);
            return false;
        }
        return true;
    }
}
